import { render, staticRenderFns } from "./ProjectContainer.vue?vue&type=template&id=794e3b5c&"
import script from "./ProjectContainer.vue?vue&type=script&lang=js&"
export * from "./ProjectContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports